module.exports = __webpack_public_path__ + "static/media/Rectangle.f2bc242c.png";